import * as yup from "yup";

export interface ISignature {
  id: number | null;
  employeeId?: number | null;
  shortSignature: string;
  fullSignature: string;
}

export interface props {
  employeeId?: number | null;
}

export const SignatureSchema = yup.object({
  shortSignature: yup.string().trim().required("Short signature is required"),
  fullSignature: yup.string().trim().required("Full signature is required"),
});

export const SignatureFields = [
  { key: "shortSignature", label: "Short Signature", desc: "Used for quick email replies." },
  { key: "fullSignature", label: "Full Signature", desc: "Used for detailed emails." },
] as const;